module.exports = __webpack_public_path__ + "img/t3-teal.87c180b1.png";